import React, {
  PropsWithChildren,
  ReactNode,
  useEffect,
  useState,
} from "react";

import Paper from "@material-ui/core/Paper";

// import "devextreme/ui/html_editor/converters/markdown";
// import HtmlEditor, {
//   Toolbar,
//   Item,
//   ImageUpload,
// } from "devextreme-react/html-editor";

import ReactMarkdown from "react-markdown";

import { mdToDraftjs, draftjsToMd } from "draftjs-md-converter";
// import { draftToMarkdown, markdownToDraft } from "markdown-draft-js";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import useMarkdownEditorStyle from "./markdown_editor.style";
import Button from "@material-ui/core/Button";
import { useUploadImage } from "../../../hooks";

export interface MarkdownEditorProps extends PropsWithChildren<{}> {
  header?: ReactNode;
  disabled?: boolean;
  value: string;
  valueChange: (e: string) => void;
}

export function MarkdownEditor(props: MarkdownEditorProps) {
  const { header, disabled, value, valueChange, children } = props;
  const classes = useMarkdownEditorStyle();

  const { uploadImage, computeImageUrl } = useUploadImage();

  const [readOnly, setReadOnly] = useState<boolean>(!!value);
  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(convertFromRaw(mdToDraftjs(value)))
  );

  useEffect(() => {
    setEditorState(
      EditorState.createWithContent(convertFromRaw(mdToDraftjs(value)))
    );
  }, [value]);

  const updateValue = () => {
    valueChange(draftjsToMd(convertToRaw(editorState.getCurrentContent())));
  };

  const onChangeStateButtonClick = () => {
    if (readOnly) {
      setReadOnly(false);
    } else {
      updateValue();
      setReadOnly(true);
    }
  };

  return (
    <>
      <Paper className={classes.root}>
        {header}
        {(readOnly || disabled) && <ReactMarkdown>{value}</ReactMarkdown>}
        {!readOnly && !disabled && (
          <Editor
            editorState={editorState}
            onEditorStateChange={setEditorState}
            wrapperClassName={classes.markdownEditorWrapper}
            editorClassName={classes.markdownEditor}
            toolbarClassName={classes.markdownToolbar}
            localization={{
              locale: "it",
            }}
            toolbar={{
              options: [
                "inline",
                "blockType",
                // "fontSize",
                // "fontFamily",
                "list",
                // "textAlign",
                // "colorPicker",
                // "link",
                // "embedded",
                "emoji",
                "image",
                // "remove",
                "history",
                // "image",
              ],
              inline: {
                inDropdown: false,
                options: ["bold", "italic"],
              },
              image: {
                className: undefined,
                component: undefined,
                popupClassName: undefined,
                urlEnabled: false,
                uploadEnabled: true,
                alignmentEnabled: false,
                uploadCallback: async (evt: File) => {
                  const image = await uploadImage(evt);

                  if (image) {
                    return {
                      data: {
                        link: computeImageUrl(image?.id),
                      },
                    };
                  }
                },
                previewImage: false,
                inputAccept:
                  "image/gif,image/jpeg,image/jpg,image/png,image/svg",
                alt: { present: false, mandatory: false },
                defaultSize: {
                  height: "auto",
                  width: "auto",
                },
              },
            }}
          />
          // <HtmlEditor
          //   height={300}
          //   defaultValue={value}
          //   valueType={"markdown"}
          //   onValueChanged={(e) => valueChange(e.value)}
          // >
          //   <ImageUpload
          //     fileUploadMode="base64"
          //     tabs={[{ name: "From This Device", value: ["file"] }]}
          //   />
          //   <Toolbar>
          //     <Item name="undo" />
          //     <Item name="redo" />
          //     <Item name="separator" />
          //     <Item name="bold" />
          //     <Item name="italic" />
          //     <Item name="image" />
          //   </Toolbar>
          // </HtmlEditor>
        )}
        {children}
        {!disabled && (
          <div className={classes.buttonContainer}>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              size="large"
              onClick={onChangeStateButtonClick}
            >
              {readOnly ? "Modifica" : "Conferma"}
            </Button>
          </div>
        )}
      </Paper>
    </>
  );
}
